import emptyPoints from "./empty-points.png";
import emptyCoupons from "./empty-coupons.png";
import emptySorteos from "./empty-sorteos.png";
import emptyPromotions from "./empty-promotions.png";
import emptyNotifications from "./empty-notifications.png";
import emptyTransfers from "./empty-transfers.png";
import error400 from "./error-400.png";
import error401 from "./error-401.png";
import error402 from "./error-402.png";
import error403 from "./error-403.png";
import error500 from "./error-500.png";

export const emptyStateIllustrations = {
  points: emptyPoints,
  coupons: emptyCoupons,
  raffles: emptySorteos,
  promotions: emptyPromotions,
  notifications: emptyNotifications,
  transfers: emptyTransfers,
};

export const errorStateIllustrations = {
  400: error400,
  401: error401,
  402: error402,
  403: error403,
  500: error500,
};
